// 9fbef606107a605d69c0edbcd8029e5d 
export default {
  countriesOptionsMap: [
    {
      id: 'US',
      displayName: 'United States',
    },
    {
      id: 'CA',
      displayName: 'Canada',
    },
  ],
  countriesStatesTable: {
    US: [
      {
        fullName: 'Alabama',
        displayName: 'AL',
        id: 'AL',
      },
      {
        fullName: 'Alaska',
        displayName: 'AK',
        id: 'AK',
      },
      {
        fullName: 'American Samoa',
        displayName: 'AS',
        id: 'AS',
      },
      {
        fullName: 'Arizona',
        displayName: 'AZ',
        id: 'AZ',
      },
      {
        fullName: 'Arkansas',
        displayName: 'AR',
        id: 'AR',
      },
      {
        id: 'AA',
        fullName: '',
        displayName: 'AA',
      },
      {
        id: 'AE',
        fullName: '',
        displayName: 'AE',
      },
      {
        id: 'AP',
        fullName: '',
        displayName: 'AP',
      },
      {
        fullName: 'California',
        displayName: 'CA',
        id: 'CA',
      },
      {
        fullName: 'Colorado',
        displayName: 'CO',
        id: 'CO',
      },
      {
        fullName: 'Connecticut',
        displayName: 'CT',
        id: 'CT',
      },
      {
        fullName: 'Delaware',
        displayName: 'DE',
        id: 'DE',
      },
      {
        fullName: 'Dist. of Columbia',
        displayName: 'DC',
        id: 'DC',
      },
      {
        fullName: '',
        displayName: 'FM',
        id: 'FM',
      },
      {
        fullName: 'Florida',
        displayName: 'FL',
        id: 'FL',
      },
      {
        fullName: 'Georgia',
        displayName: 'GA',
        id: 'GA',
      },
      {
        fullName: 'Guam',
        displayName: 'GU',
        id: 'GU',
      },
      {
        fullName: 'Hawaii',
        displayName: 'HI',
        id: 'HI',
      },
      {
        fullName: 'Idaho',
        displayName: 'ID',
        id: 'ID',
      },
      {
        fullName: 'Illinois',
        displayName: 'IL',
        id: 'IL',
      },
      {
        fullName: 'Indiana',
        displayName: 'IN',
        id: 'IN',
      },
      {
        fullName: 'Iowa',
        displayName: 'IA',
        id: 'IA',
      },
      {
        fullName: 'Kansas',
        displayName: 'KS',
        id: 'KS',
      },
      {
        fullName: 'Kentucky',
        displayName: 'KY',
        id: 'KY',
      },
      {
        fullName: 'Louisiana',
        displayName: 'LA',
        id: 'LA',
      },
      {
        fullName: 'Maine',
        displayName: 'ME',
        id: 'ME',
      },
      {
        fullName: 'Marshall Islands',
        displayName: 'MH',
        id: 'MH',
      },
      {
        fullName: 'Maryland',
        displayName: 'MD',
        id: 'MD',
      },
      {
        fullName: 'Massachusetts',
        displayName: 'MA',
        id: 'MA',
      },
      {
        fullName: 'Michigan',
        displayName: 'MI',
        id: 'MI',
      },
      {
        fullName: 'Minnesota',
        displayName: 'MN',
        id: 'MN',
      },
      {
        fullName: 'Mississippi',
        displayName: 'MS',
        id: 'MS',
      },
      {
        fullName: 'Missouri',
        displayName: 'MO',
        id: 'MO',
      },
      {
        fullName: 'Montana',
        displayName: 'MT',
        id: 'MT',
      },
      {
        fullName: 'Nebraska',
        displayName: 'NE',
        id: 'NE',
      },
      {
        fullName: 'Nevada',
        displayName: 'NV',
        id: 'NV',
      },
      {
        fullName: 'New Hampshire',
        displayName: 'NH',
        id: 'NH',
      },
      {
        fullName: 'New Jersey',
        displayName: 'NJ',
        id: 'NJ',
      },
      {
        fullName: 'New Mexico',
        displayName: 'NM',
        id: 'NM',
      },
      {
        fullName: 'New York',
        displayName: 'NY',
        id: 'NY',
      },
      {
        fullName: 'North Carolina',
        displayName: 'NC',
        id: 'NC',
      },
      {
        fullName: 'North Dakota',
        displayName: 'ND',
        id: 'ND',
      },
      {
        fullName: 'Northern Marianas',
        displayName: 'MP',
        id: 'MP',
      },
      {
        fullName: 'Ohio',
        displayName: 'OH',
        id: 'OH',
      },
      {
        fullName: 'Oklahoma',
        displayName: 'OK',
        id: 'OK',
      },
      {
        fullName: 'Oregon',
        displayName: 'OR',
        id: 'OR',
      },
      {
        fullName: 'Palau',
        displayName: 'PW',
        id: 'PW',
      },
      {
        fullName: 'Pennsylvania',
        displayName: 'PA',
        id: 'PA',
      },
      {
        fullName: 'Puerto Rico',
        displayName: 'PR',
        id: 'PR',
      },
      {
        fullName: 'Rhode Island',
        displayName: 'RI',
        id: 'RI',
      },
      {
        fullName: 'South Carolina',
        displayName: 'SC',
        id: 'SC',
      },
      {
        fullName: 'South Dakota',
        displayName: 'SD',
        id: 'SD',
      },
      {
        fullName: 'Tennessee',
        displayName: 'TN',
        id: 'TN',
      },
      {
        fullName: 'Texas',
        displayName: 'TX',
        id: 'TX',
      },
      {
        fullName: 'Utah',
        displayName: 'UT',
        id: 'UT',
      },
      {
        fullName: 'Vermont',
        displayName: 'VT',
        id: 'VT',
      },
      {
        fullName: 'Virginia',
        displayName: 'VA',
        id: 'VA',
      },
      {
        fullName: 'Virgin Islands',
        displayName: 'VI',
        id: 'VI',
      },
      {
        fullName: 'Washington',
        displayName: 'WA',
        id: 'WA',
      },
      {
        fullName: 'West Virginia',
        displayName: 'WV',
        id: 'WV',
      },
      {
        fullName: 'Wisconsin',
        displayName: 'WI',
        id: 'WI',
      },
      {
        fullName: 'Wyoming',
        displayName: 'WY',
        id: 'WY',
      },
    ],
    CA: [
      {
        id: 'BC',
        fullName: 'British Columbia',
        displayName: 'BC',
      },
      {
        id: 'ON',
        fullName: 'Ontario',
        displayName: 'ON',
      },
      {
        id: 'NL',
        fullName: 'Newfoundland and Labrador',
        displayName: 'NL',
      },
      {
        id: 'NS',
        fullName: 'Nova Scotia',
        displayName: 'NS',
      },
      {
        id: 'PE',
        fullName: 'Prince Edward Island',
        displayName: 'PE',
      },
      {
        id: 'NB',
        fullName: 'New Brunswick',
        displayName: 'NB',
      },
      {
        id: 'QC',
        fullName: 'Quebec',
        displayName: 'QC',
      },
      {
        id: 'MB',
        fullName: 'Manitoba',
        displayName: 'MB',
      },
      {
        id: 'SK',
        fullName: 'Saskatchewan',
        displayName: 'SK',
      },
      {
        id: 'AB',
        fullName: 'Alberta',
        displayName: 'AB',
      },
      {
        id: 'NT',
        fullName: 'Northwest Territories',
        displayName: 'NT',
      },
      {
        id: 'NU',
        fullName: 'Nunavut',
        displayName: 'NU',
      },
      {
        id: 'YT',
        fullName: 'Yukon',
        displayName: 'YT',
      },
    ],
  },
};
